
const scrollToTop = () => {
  window.scrollTo({
    left: 0,
    top: 0,
  })
}

const EMAIL: string = 'support@gogocredi.com';
const WHATS_APP: string = '';
const APP_LINK : string = 'https://play.google.com/store/apps/details?id=com.gogocredi.app.android';

export {
  scrollToTop,
  EMAIL,
  APP_LINK,
  WHATS_APP,
}
